<div class="full-page app-home-wrapper background-image">
  <div class="grid-container">
    <div class="grid-container_top">
      <img class="grid-container_img" src="assets/logos/PyxisLogo.png" alt="PYXIS Logo">
      <h4 class="grid-container_title">Integrity Management</h4>
    </div>
    <section class="app-forbidden-content-container-grid">
      <h1>403</h1>
      <h3><i class="pe-7s-help2" aria-hidden="true"></i>Forbidden</h3>
      <p>You are not authorised to view this page or perform this operation.</p>
    </section>
    <section class="app-forbidden-content-container-grid">
      <img class="app-forbidden-content-container_img" src="assets/logos/MtlFlatLogo.png" alt="MTL" />
      <p class="app-forbidden-content-container-login_text copy-light"> For all Pyxis enquiries &amp; support please contact <a href="http://www.technical-limits.com#contact" class="home-link">Marine Technical Limits</a> or call 01224 208180.</p>
      <a routerLink="/" class="button-info-central error-btn">Return Home</a>
    </section>
  </div>
</div>
